module.exports = __webpack_public_path__ + "img/arrow-down-select.79ccdb23.svg";